/**
 * @file control-bar.js
 */
'use strict';

exports.__esModule = true;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _componentJs = require('../component.js');

var _componentJs2 = _interopRequireDefault(_componentJs);

// Required children

var _playToggleJs = require('./play-toggle.js');

var _playToggleJs2 = _interopRequireDefault(_playToggleJs);

var _timeControlsCurrentTimeDisplayJs = require('./time-controls/current-time-display.js');

var _timeControlsCurrentTimeDisplayJs2 = _interopRequireDefault(_timeControlsCurrentTimeDisplayJs);

var _timeControlsDurationDisplayJs = require('./time-controls/duration-display.js');

var _timeControlsDurationDisplayJs2 = _interopRequireDefault(_timeControlsDurationDisplayJs);

var _timeControlsTimeDividerJs = require('./time-controls/time-divider.js');

var _timeControlsTimeDividerJs2 = _interopRequireDefault(_timeControlsTimeDividerJs);

var _timeControlsRemainingTimeDisplayJs = require('./time-controls/remaining-time-display.js');

var _timeControlsRemainingTimeDisplayJs2 = _interopRequireDefault(_timeControlsRemainingTimeDisplayJs);

var _liveDisplayJs = require('./live-display.js');

var _liveDisplayJs2 = _interopRequireDefault(_liveDisplayJs);

var _progressControlProgressControlJs = require('./progress-control/progress-control.js');

var _progressControlProgressControlJs2 = _interopRequireDefault(_progressControlProgressControlJs);

var _fullscreenToggleJs = require('./fullscreen-toggle.js');

var _fullscreenToggleJs2 = _interopRequireDefault(_fullscreenToggleJs);

var _volumeControlVolumeControlJs = require('./volume-control/volume-control.js');

var _volumeControlVolumeControlJs2 = _interopRequireDefault(_volumeControlVolumeControlJs);

var _volumeMenuButtonJs = require('./volume-menu-button.js');

var _volumeMenuButtonJs2 = _interopRequireDefault(_volumeMenuButtonJs);

var _muteToggleJs = require('./mute-toggle.js');

var _muteToggleJs2 = _interopRequireDefault(_muteToggleJs);

var _textTrackControlsChaptersButtonJs = require('./text-track-controls/chapters-button.js');

var _textTrackControlsChaptersButtonJs2 = _interopRequireDefault(_textTrackControlsChaptersButtonJs);

var _textTrackControlsDescriptionsButtonJs = require('./text-track-controls/descriptions-button.js');

var _textTrackControlsDescriptionsButtonJs2 = _interopRequireDefault(_textTrackControlsDescriptionsButtonJs);

var _textTrackControlsSubtitlesButtonJs = require('./text-track-controls/subtitles-button.js');

var _textTrackControlsSubtitlesButtonJs2 = _interopRequireDefault(_textTrackControlsSubtitlesButtonJs);

var _textTrackControlsCaptionsButtonJs = require('./text-track-controls/captions-button.js');

var _textTrackControlsCaptionsButtonJs2 = _interopRequireDefault(_textTrackControlsCaptionsButtonJs);

var _audioTrackControlsAudioTrackButtonJs = require('./audio-track-controls/audio-track-button.js');

var _audioTrackControlsAudioTrackButtonJs2 = _interopRequireDefault(_audioTrackControlsAudioTrackButtonJs);

var _playbackRateMenuPlaybackRateMenuButtonJs = require('./playback-rate-menu/playback-rate-menu-button.js');

var _playbackRateMenuPlaybackRateMenuButtonJs2 = _interopRequireDefault(_playbackRateMenuPlaybackRateMenuButtonJs);

var _spacerControlsCustomControlSpacerJs = require('./spacer-controls/custom-control-spacer.js');

var _spacerControlsCustomControlSpacerJs2 = _interopRequireDefault(_spacerControlsCustomControlSpacerJs);

/**
 * Container of main controls
 *
 * @extends Component
 * @class ControlBar
 */

var ControlBar = (function (_Component) {
  _inherits(ControlBar, _Component);

  function ControlBar() {
    _classCallCheck(this, ControlBar);

    _Component.apply(this, arguments);
  }

  /**
   * Create the component's DOM element
   *
   * @return {Element}
   * @method createEl
   */

  ControlBar.prototype.createEl = function createEl() {
    return _Component.prototype.createEl.call(this, 'div', {
      className: 'vjs-control-bar',
      dir: 'ltr'
    }, {
      'role': 'group' // The control bar is a group, so it can contain menuitems
    });
  };

  return ControlBar;
})(_componentJs2['default']);

ControlBar.prototype.options_ = {
  loadEvent: 'play',
  children: ['playToggle', 'volumeMenuButton', 'currentTimeDisplay', 'timeDivider', 'durationDisplay', 'progressControl', 'liveDisplay', 'remainingTimeDisplay', 'customControlSpacer', 'playbackRateMenuButton', 'chaptersButton', 'descriptionsButton', 'subtitlesButton', 'captionsButton', 'audioTrackButton', 'fullscreenToggle']
};

_componentJs2['default'].registerComponent('ControlBar', ControlBar);
exports['default'] = ControlBar;
module.exports = exports['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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